<template>
  <div class="tile is-parent">
    <div class="p-4">
      <img v-bind:src="`https://evgeshayoga.com${this.teacher.picture}`" v-bind:alt="this.teacher.name"
           class="card-image teacher"/>
      <h3 class="has-text-centered	mt-2">{{this.teacher.name }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeacherCard',
  props: ['teacher'],
  methods: {},
}
</script>

<style>
  .card-image.teacher {
    width: 100%;
  }
</style>
